import { render } from "./Copify.vue?vue&type=template&id=f41e631c"
import script from "./Copify.vue?vue&type=script&lang=js"
export * from "./Copify.vue?vue&type=script&lang=js"

import "./Copify.vue?vue&type=style&index=0&id=f41e631c&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__